import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-50 py-8 px-4 border-t border-gray-200" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <div className="mb-6" data-id="element-180">
          <h3 className="text-lg font-semibold text-gray-700 mb-4" data-id="element-181">
            Disclaimer:
          </h3>
          <p className="text-sm text-gray-600" data-id="element-182">
            Unfreeze is a wellness education program and is not intended to
            diagnose, treat, or cure any medical or mental health condition.
            Always consult with a licensed healthcare provider before beginning
            any new wellness program, especially if you are currently in
            treatment or on medication. Unfreeze is not a substitute for
            professional therapy, medical care, or crisis support.
          </p>
        </div>
        <div className="flex flex-wrap justify-center text-sm text-gray-600" data-id="element-183">
          <a href="#" className="mx-3 hover:text-purple-600 cursor-pointer" data-id="element-184">
            Terms of Service
          </a>
          <a href="#" className="mx-3 hover:text-purple-600 cursor-pointer" data-id="element-185">
            Privacy Policy
          </a>
          <span className="mx-3 hover:text-purple-600 cursor-pointer" data-id="element-186">
            Contact: support@neurotoned.com
          </span>
        </div>
        <div className="mt-6 text-center" data-id="element-187">
          <a href="#" data-id="element-188">
            <span className="text-xl font-bold text-purple-700" data-id="element-189">Unfreeze</span>
            <span className="text-xl font-light text-teal-600 ml-1" data-id="element-190">
              by Neurotoned
            </span>
          </a>
          <p className="text-sm text-gray-500 mt-2" data-id="element-191">
            © {new Date().getFullYear()} Neurotoned. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}